/* Sami Jewels PDP: normalize legacy "DETAILS" description markup into real bullets.
 * Presentation-only, DOM-based, idempotent. Never touches product data.
 * Usage: normalizePdpDetails(document) or normalizePdpDetails(someElement)
 */
(function (global) {
  'use strict';
  var SCOPE = '.x-block-description, [class*="x-block-collapsible-tab"]';
  var EXCLUDE = 'form, product-form, [class*="product-form"], [class*="guide"], [id*="guide"], [class*="personaliz"], [id*="personaliz"], [data-sj-no-normalize]';
  var HEADING_RE = /^(product\s+details|details|specifications)\s*:?$/i;
  var DONE = 'data-sj-details-normalized';

  function txt(n) { return (n.textContent || '').replace(/[\s\u00a0]+/g, ' ').trim(); }
  function isHeading(el) {
    if (!el || el.nodeType !== 1) return false;
    if (/^H[1-6]$/.test(el.tagName)) return true;
    // <p><strong>DETAILS</strong></p> style headings
    if (el.tagName === 'P' && el.children.length === 1 && /^(STRONG|B)$/.test(el.children[0].tagName) &&
        txt(el) === txt(el.children[0]) && txt(el).length < 40) return true;
    return false;
  }
  function isDetailsHeading(el) { return isHeading(el) && HEADING_RE.test(txt(el)); }
  function excluded(el, container) {
    if (el.querySelector && el.querySelector('form, input, select, textarea, button')) return true;
    var c = el.closest && el.closest(EXCLUDE);
    return !!(c && (container.contains(c) || c.contains(container)));
  }
  // Split a <p> into line groups by <br> (top-level only); returns array of node arrays.
  function lines(p) {
    var doc = p.ownerDocument, out = [], startNode = p, startOffset = 0;
    Array.prototype.forEach.call(p.querySelectorAll('br'), function (br) {
      var range = doc.createRange(); range.setStart(startNode, startOffset); range.setEndBefore(br);
      out.push(Array.prototype.slice.call(range.cloneContents().childNodes));
      startNode = br.parentNode; startOffset = Array.prototype.indexOf.call(startNode.childNodes, br) + 1;
    });
    var last = doc.createRange(); last.setStart(startNode, startOffset); last.setEnd(p, p.childNodes.length);
    out.push(Array.prototype.slice.call(last.cloneContents().childNodes));
    return out.filter(function(g) { return g.some(function(n) { return txt(n); }); });
  }
  function startsWithLabel(group) {
    for (var i = 0; i < group.length; i++) {
      var n = group[i];
      if (n.nodeType === 3 && !txt(n)) continue;
      if (n.nodeType === 1 && n.tagName === 'META') continue;
      return n.nodeType === 1 && /^(STRONG|B)$/.test(n.tagName);
    }
    return false;
  }
  function isSpecParagraph(p) {
    if (p.tagName !== 'P') return false;
    var g = lines(p);
    return !!g.length && g.every(function(group) {
      return markedSpec(groupText(group, p.ownerDocument));
    });
  }
  function toList(p, doc) {
    var ul = doc.createElement('ul');
    ul.className = 'sj-pdp-specs';
    ul.setAttribute('data-sj-specs', 'converted');
    lines(p).forEach(function (g) {
      var li = doc.createElement('li');
      // trim leading/trailing whitespace-only text nodes
      while (g.length && g[0].nodeType === 3 && !txt(g[0])) g.shift();
      while (g.length && g[g.length - 1].nodeType === 3 && !txt(g[g.length - 1])) g.pop();
      g.forEach(function (n) { li.appendChild(n); });
      var lab = li.firstElementChild;
      if (lab && /^(STRONG|B)$/.test(lab.tagName) && li.firstChild === lab) lab.classList.add('sj-pdp-spec-label');
      ul.appendChild(li);
    });
    p.parentNode.replaceChild(ul, p);
    return ul;
  }

  // Recognize explicit legacy labels only. Never infer measurements or materials.
  var FIELD_RE = /^(materials?(?:\s*(?:&|and|\/)\s*plating)?|metal|plating|finish(?:es)?|available\s+sizes?|sizes?(?:\s+options)?|ring\s+(?:size|width|height)|bracelet\s+(?:lengths?|width)|necklace\s+lengths?|lengths?|width|height|thickness|dimensions?|stone(?:s|\s+(?:dimensions?|size|shape|shape\/sizing))?|closure(?:\s+type)?|sold\s+as|hypoallergenic|durability|style|construction|weight|inner\s+diameter|outer\s+diameter|chain\s+length|extender|base\s+metal|material\s*&\s*finish|gemstone|diamond[\s-]+cut|setting\s+type|number\s+of\s+stones|diamond\s+color|clarity|total\s+carat\s+weight|width\s+of\s+band)$/i;
  var SEPARATOR_RE = /^([^:➤➢►▶→➣\n]{1,48}?)\s*[:➤➢►▶→➣]\s*/;
  function detailText(s) {
    return s.replace(/[\s\u00a0\-–—:•*]/g, '').toLowerCase();
  }
  function detailLine(s) {
    return /^(details|productdetails|specifications)$/.test(detailText(s));
  }
  function explicitLabel(s) {
    var m = s.match(SEPARATOR_RE);
    return m && FIELD_RE.test(m[1].trim()) ? m : null;
  }
  function markedSpec(s) {
    return /^[•●▪]\s*/.test(s) || !!explicitLabel(s);
  }
  function groupText(g, doc) {
    var e = doc.createElement('div');
    g.forEach(function (n) { e.appendChild(n.cloneNode(true)); });
    return txt(e);
  }
  // Remove only a leading presentation bullet, preserving all inline links/content.
  function trimBullet(el) {
    var walk = el.ownerDocument.createTreeWalker(el, 4), n;
    while ((n = walk.nextNode())) {
      if (!txt(n)) continue;
      var old = n.nodeValue;
      n.nodeValue = old.replace(/^(\s*)[•●▪]\s*/, '$1');
      return old !== n.nodeValue ? 1 : 0;
    }
    return 0;
  }
  function formatLabel(li) {
    var label = explicitLabel(txt(li));
    if (!label) return 0;
    var existing = li.querySelector('strong.sj-pdp-spec-label');
    if (existing && txt(existing) === label[1].trim() + ':') return 0;
    var doc = li.ownerDocument, walker = doc.createTreeWalker(li, 4), node;
    var raw = '', nodes = [];
    while ((node = walker.nextNode())) { nodes.push(node); raw += node.nodeValue; }
    var match = raw.replace(/^\s+/, '').match(SEPARATOR_RE);
    if (!match || !FIELD_RE.test(match[1].trim())) return 0;
    var end = raw.length - raw.replace(/^\s+/, '').length + match[0].length;
    var range = doc.createRange(), consumed = 0;
    range.setStart(nodes[0], 0);
    for (var i = 0; i < nodes.length; i++) {
      if (consumed + nodes[i].nodeValue.length >= end) {
        range.setEnd(nodes[i], end - consumed); break;
      }
      consumed += nodes[i].nodeValue.length;
    }
    range.deleteContents();
    var strong = doc.createElement('strong');
    strong.className = 'sj-pdp-spec-label';
    strong.textContent = match[1].trim() + ':';
    range.insertNode(strong);
    strong.after(doc.createTextNode(' '));
    return 1;
  }
  function prepareLegacyDescription(container) {
    if (!container.matches('.x-block-description')) return 0;
    var rte = container.querySelector('.rte'), doc = container.ownerDocument, changed = 0;
    if (!rte) return 0;
    // Explicit bullet/label lines can share one paragraph with the introduction.
    Array.prototype.slice.call(rte.querySelectorAll('p')).forEach(function (p) {
      if (excluded(p, container) || p.closest('li') || !p.querySelector('br')) return;
      var groups = lines(p), strings = groups.map(function (g) { return groupText(g, doc); });
      if (strings.filter(markedSpec).length < 2) return;
      var frag = doc.createDocumentFragment(), list = null;
      groups.forEach(function (group, i) {
        var s = strings[i], el;
        if (detailLine(s)) {
          list = null; el = doc.createElement('h3'); el.textContent = 'DETAILS';
          frag.appendChild(el);
        } else if (markedSpec(s)) {
          if (!list) { list = doc.createElement('ul'); frag.appendChild(list); }
          el = doc.createElement('li');
          group.forEach(function (n) { el.appendChild(n); });
          trimBullet(el); list.appendChild(el);
        } else {
          list = null; el = doc.createElement('p');
          group.forEach(function (n) { el.appendChild(n); });
          frag.appendChild(el);
        }
      });
      p.replaceWith(frag); changed++;
    });
    // Standalone bullet paragraphs belonging to a preceding specification list.
    Array.prototype.slice.call(rte.querySelectorAll('p')).forEach(function (p) {
      if (excluded(p, container) || p.closest('li') || !/^[•●▪]/.test(txt(p))) return;
      var previous = p.previousElementSibling;
      if (!previous || previous.tagName !== 'UL') return;
      var li = doc.createElement('li');
      while (p.firstChild) li.appendChild(p.firstChild);
      trimBullet(li); previous.appendChild(li); p.remove(); changed++;
    });
    // Normalize existing heading variants to the same semantic element and wording.
    var candidates = Array.prototype.slice.call(rte.querySelectorAll('h1,h2,h3,h4,h5,h6,p,div,strong,b,span'));
    candidates.filter(function (e) {
      return detailLine(txt(e)) && !excluded(e, container) &&
        !(e.parentElement !== rte && detailLine(txt(e.parentElement)));
    }).forEach(function (e) {
      if (e.tagName === 'H3' && txt(e) === 'DETAILS') return;
      var h = doc.createElement('h3'); h.textContent = 'DETAILS';
      e.replaceWith(h); changed++;
    });
    // Label-only paragraphs after DETAILS, even within harmless nested wrappers.
    Array.prototype.slice.call(rte.querySelectorAll('p')).forEach(function (p) {
      if (excluded(p, container) || p.closest('li')) return;
      var strings = lines(p).map(function (g) { return groupText(g, doc); });
      if (strings.length && strings.every(function (s) { return !!explicitLabel(s); })) {
        toList(p, doc); changed++;
      }
    });
    Array.prototype.forEach.call(rte.querySelectorAll('li'), function (li) {
      if (excluded(li, container)) return;
      changed += trimBullet(li);
      changed += formatLabel(li);
    });
    return changed;
  }

  function normalizeContainer(container) {
    var doc = container.ownerDocument;
    var changed = prepareLegacyDescription(container);
    var heads = Array.prototype.filter.call(container.querySelectorAll('h1,h2,h3,h4,h5,h6,p'), isDetailsHeading);
    heads.forEach(function (h) {
      if (excluded(h, container)) return;
      if (!h.classList.contains('sj-pdp-details-heading')) { h.classList.add('sj-pdp-details-heading'); changed++; }
      var n = h.nextElementSibling;
      while (n && !isHeading(n)) {
        var next = n.nextElementSibling;
        if (!excluded(n, container)) {
          if ((n.tagName === 'UL' || n.tagName === 'OL') && !n.classList.contains('sj-pdp-specs')) {
            n.classList.add('sj-pdp-specs'); changed++;
          } else if (isSpecParagraph(n)) { toList(n, doc); changed++; }
          // prose paragraphs and single-link paragraphs are left untouched
        }
        n = next;
      }
    });
    // Legacy catalog descriptions may have specifications but no DETAILS title.
    // Add a single presentation heading inside the actual product description only.
    // Do not label shipping/returns accordions, forms, navigation or introductory prose.
    if (container.matches('.x-block-description') && !heads.length) {
      var rte = container.querySelector('.rte');
      var specs = rte && Array.prototype.find.call(rte.querySelectorAll('ul,ol'), function (el) {
        return !excluded(el, container) && !el.closest('nav,li') && txt(el);
      });
      if (specs) {
        var title = doc.createElement('h3');
        title.className = 'sj-pdp-details-heading';
        title.setAttribute('data-sj-details-added', 'true');
        title.textContent = 'DETAILS';
        specs.parentNode.insertBefore(title, specs);
        changed++;
      }
    }
    // Preserve existing list semantics and product facts.

    Array.prototype.forEach.call(container.querySelectorAll('ul,ol'), function (ul) {
      if (!ul.classList.contains('sj-pdp-specs') && !excluded(ul, container) && !ul.closest('nav')) {
        ul.classList.add('sj-pdp-specs'); changed++;
      }
    });
    // The original headed-paragraph pass may also create lists; finish in this run.
    if (container.matches('.x-block-description')) {
      Array.prototype.forEach.call(container.querySelectorAll('.rte li'), function (li) {
        if (!excluded(li, container)) { changed += trimBullet(li); changed += formatLabel(li); }
      });
    }
    container.setAttribute(DONE, '1');
    return changed;
  }

  function normalizePdpDetails(root) {
    root = root || (typeof document !== 'undefined' ? document : null);
    if (!root || !root.querySelectorAll) return 0;
    var list = Array.prototype.slice.call(root.querySelectorAll(SCOPE));
    if (root.nodeType === 1 && root.matches(SCOPE)) list.unshift(root);
    // only innermost-relevant content; skip excluded containers
    var total = 0;
    list.forEach(function (c) {
      var bad = c.closest(EXCLUDE);
      if (bad) return;
      total += normalizeContainer(c);
    });
    return total; // number of mutations; 0 on re-run (idempotent)
  }

  // Optional rerender-safe installer: debounced, ignores its own mutations.
  function installPdpDetailsNormalizer(root) {
    root = root || document;
    if (root.__sjDetailsObserver) return root.__sjDetailsObserver;
    var busy = false, queued = false, obs;
    function run() {
      queued = false; if (busy) return; busy = true;
      try { obs && obs.disconnect(); normalizePdpDetails(root); }
      finally { busy = false; obs && obs.observe(root.body || root, { childList: true, subtree: true }); }
    }
    run();
    if (typeof MutationObserver !== 'undefined') {
      obs = new MutationObserver(function () {
        if (busy || queued) return; queued = true;
        (global.requestAnimationFrame || setTimeout)(run);
      });
      obs.observe(root.body || root, { childList: true, subtree: true });
    }
    root.__sjDetailsObserver = obs;
    return obs;
  }

  global.normalizePdpDetails = normalizePdpDetails;
  global.installPdpDetailsNormalizer = installPdpDetailsNormalizer;
  if (typeof module !== 'undefined' && module.exports) module.exports = { normalizePdpDetails: normalizePdpDetails, installPdpDetailsNormalizer: installPdpDetailsNormalizer };
})(typeof window !== 'undefined' ? window : globalThis);

if(document.querySelector('.sj-mariner-main')) installPdpDetailsNormalizer(document.querySelector('.sj-mariner-main'));
